import React from "react";
import assign from "lodash/assign";
import { Link } from "react-router";
import {
  CircularProgress,
  RaisedButton,
  FlatButton,
  Card,
  Checkbox
} from "material-ui";
import { colors as Colors } from "material-ui/styles";
import moment from "moment-timezone";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Elements } from "react-stripe-elements";
import CloseIcon from "material-ui/svg-icons/navigation/close";

import * as util from "../../util";
import OrderSummary from "./order-summary.jsx";
import OrderSummarySundance from "./order-summary-sundance.jsx";
import OrderSeatPicker from "./order-seat-picker.jsx";
import OrderQuantitySelect from "./order-quantity-select.jsx";
import OrderQuantitySelectSundance from "./order-quantity-select-sundance.jsx";
import OrderActionButtons from "./order-action-buttons.jsx";
import OrderExtraEntry from "./order-extra-entry.jsx";
import AccountCreation from "./account-creation.jsx";
import PaymentMethodUpdater from "./payment-method-updater.jsx";
import OrderPaymentWizard from "./order-payment-wizard.jsx";
import PaymentMethodEntrySundance from "./payment-method-entry-sundance.jsx";
import CheckoutOrderSummary from "./checkout-order-summary.jsx";
import ReselectSeatsWarning from "./reselect-seats-warning.jsx";
import LeaveModalWarning from "./leave-modal-warning.jsx";
import ContactInfoUpdater from "./contact-info-updater.jsx";
import SupplementaryDataCheckoutEntry from "./supplementary-data-checkout-entry.jsx";
import InjectedTenantHtml from "./injected-tenant-html.jsx";
import CountdownText from "./countdown-text.jsx";
import LinkLike from "./link-like.jsx";
import CurrencyField from "./currency-field.jsx";
import HorizontalSeparator from "./horizontal-separator.jsx";

import api from "../../utils/api";
import OrderUtil from "../../utils/OrderUtil";
import PersonStore from "../../stores/PersonStore";
import CouponStore from "../../stores/CouponStore";
import PassStore from "../../stores/PassStore";

import CouponActions from "../../actions/CouponActions";
import OrderActions from "../../actions/OrderActions";
import PersonActions from "../../actions/PersonActions";
import PassActions from "../../actions/PassActions";

class Checkout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasAcceptedTerms: false,
      showExpiredWarning: false,
      showSeatWarning: false,
      showLeaveWarning: false,
      appliedPassData: null,
      heartbeatId: null,
      isUpdatingPayment: null,
      isUpdatingSundancePayment: null,
      sundanceCouponStatus: undefined,
      isSubmitting: false,
      paymentWizardSubmitDisabled: true,
      mailingListOptIn: undefined,
      waitingForCheckoutCompletion: null
    };

    this.setPaymentWizardRef = element => {
      this.paymentWizard = element;
    };
    this.setPaymentMethodUpdaterRef = element => {
      this.paymentMethodUpdater = element;
    };
    this.setPaymentWizardDisabledState = disabled => {
      this.setState({
        paymentWizardSubmitDisabled: disabled
      });
    };

    this.startCountdown = this.startCountdown.bind(this);
    this.fireHeartbeat = this.fireHeartbeat.bind(this);
    this.onCountdownExpired = this.onCountdownExpired.bind(this);
    this.onModalCancel = this.onModalCancel.bind(this);
    this.isSundance = this.isSundance.bind(this);
    this.useSundanceModals = this.useSundanceModals.bind(this);
    this.submitSundanceCheckout = this.submitSundanceCheckout.bind(this);
    this._getProcessedOrder = this._getProcessedOrder.bind(this);
    this._repickSeats = this._repickSeats.bind(this);
    this._repickSeatsCancel = this._repickSeatsCancel.bind(this);
    this._repickSeatsConfirm = this._repickSeatsConfirm.bind(this);
    this._leaveModalCancel = this._leaveModalCancel.bind(this);
    this._leaveModalConfirm = this._leaveModalConfirm.bind(this);
    this.getOrderData = this.getOrderData.bind(this);
    this.onOrderCanceled = this.onOrderCanceled.bind(this);
    this.onOrderCompleted = this.onOrderCompleted.bind(this);
    this.onOrderWaitingForCompletion =
      this.onOrderWaitingForCompletion.bind(this);
    this.onOpenPaymentMethodUpdater =
      this.onOpenPaymentMethodUpdater.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      container: {
        textAlign: "center",
        fontSize: "11pt"
      },
      error: {
        color: "#fff",
        backgroundColor: Colors.red600,
        padding: 10
      },
      accountDetail: {},
      account: {
        backgroundColor: Colors.yellow300,
        padding: 10,
        marginTop: 10
      },
      recurrence: {
        border: "1px solid #ccc",
        borderRadius: 4,
        padding: 10,
        marginTop: 10
      },
      payment: {
        backgroundColor: Colors.yellow300,
        padding: 10,
        paddingTop: 0,
        marginTop: -10
      },
      savedCard: {
        fontWeight: "bold"
      },
      terms: {
        textAlign: "left",
        marginLeft: "1em",
        marginTop: "2em"
      },
      timeout: {
        textAlign: "center",
        padding: 10,
        backgroundColor: Colors.yellow300,
        marginBottom: 20
      },

      // interstitial
      donateButtonsContainer: {
        marginTop: "2em",
        textAlign: "center",
        marginRight: -10,
        marginBottom: 20
      },
      donateButton: {
        marginRight: 10,
        marginBottom: 10,
        minWidth: 90,
        height: 50
      },
      donateButtonLabel: {
        fontSize: "1.25em"
      },

      // Sundance
      sundanceHeader: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        wrap: "",
        height: 25,
        paddingBottom: 10
      },
      sundanceHeaderTitle: {
        fontSize: "2em",
        fontWeight: "bold"
      },
      sundanceHeaderCloseButton: {
        cursor: "pointer"
      },
      sundanceHeaderCloseIcon: {
        width: 50,
        height: 50,
        marginTop: -18,
        marginRight: -10
      },
      sundanceContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap"
      },
      sundanceLeftContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        maxWidth: 390,
        marginRight: 25
      },
      sundanceRightContainer: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center"
      },
      sundanceSectionHeader: {
        textAlign: "left",
        paddingTop: 15
      },
      sundanceSectionHeaderText: {
        fontSize: "1.5em",
        fontWeight: "bold"
      },
      sundancePaymentMethodContainer: {
        width: "100%"
      },
      sundanceCheckoutSummary: {
        border: "2px solid #e9e9e9",
        padding: 15,
        paddingTop: 0,
        marginTop: 5,
        minWidth: 230,
        maxWidth: 230
      },
      sundanceTerms: {
        textAlign: "center",
        marginLeft: 0,
        marginTop: "2em"
      },
      sundanceTermsCheckboxInput: {
        width: 32
      },
      sundanceTermsCheckboxLabel: {
        textAlign: "left",
        paddingLeft: 5,
        fontSize: 13
      },
      sundanceCheckoutButtonContainer: {
        textAlign: "center",
        marginTop: 30
      },
      sundanceCheckoutButton: {
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: 5
      },
      sundanceCheckoutButtonLabel: {
        fontSize: "0.8em"
      },
      sundancePayment: {
        padding: 0,
        textAlign: "left"
      },
      sundanceDonationText: {
        textAlign: "left"
      },
      sundanceDonateButtonsContainer: {
        marginTop: "1em",
        textAlign: "left",
        marginRight: -10,
        marginBottom: 20
      },
      sundanceDonateButton: {
        marginRight: 10,
        marginBottom: 10,
        minWidth: 62,
        height: 30
      },
      sundanceDonateButtonLabel: {
        fontSize: "1em"
      },
      sundanceDiscountError: {
        paddingTop: 10,
        paddingBottom: 15
      }
    };
  }

  _repickSeats() {
    this.setState({ showSeatWarning: true });
  }

  _repickSeatsCancel() {
    this.setState({ showSeatWarning: false });
  }

  _repickSeatsConfirm() {
    OrderActions.updateCurrentOrder({
      seats_confirmed: false
    });
    clearInterval(this.state.heartbeatId);
    //this.fireHeartbeat(0);
    this.setState({ showSeatWarning: false, heartbeatId: null });
  }

  startCountdown() {
    // wait two seconds to allow for the setInterval API call to beat the seats.io timer
    // or it can accidentally timeout before the heartbeat updates the server
    // note: we fire this initial heartbeat because otherwise a refresh in the first
    // 59 seconds would leave the reservation on hold for the full 6 minutes
    setTimeout(
      function () {
        this.fireHeartbeat(1);
      }.bind(this),
      2000
    );
    // similar idea here, only wait 55 seconds to allow for the API call to beat the seats.io timer of 60 seconds
    // and 55 seconds gives the call a little extra time in case seats.io is overwhelemd and responds slower
    const heartbeatId = setInterval(
      function () {
        this.fireHeartbeat(1);
      }.bind(this),
      30000
    );
    this.setState({ heartbeatId: heartbeatId });
  }

  onCountdownExpired() {
    clearInterval(this.state.heartbeatId);
    this.fireHeartbeat(0);
    this.setState({ showExpiredWarning: true, heartbeatId: null });
  }

  onModalCancel() {
    if (this.state.heartbeatId) {
      this.setState({ showLeaveWarning: true });
    } else {
      this.props.cancel();
    }
  }

  _leaveModalCancel() {
    this.setState({ showLeaveWarning: false });
  }

  _leaveModalConfirm() {
    OrderActions.updateCurrentOrder({
      seats_confirmed: false
    });
    clearInterval(this.state.heartbeatId);
    this.fireHeartbeat(0);
    this.setState({ showLeaveWarning: false, heartbeatId: null });
    this.props.cancel();
  }

  fireHeartbeat(minutes) {
    api.request(
      {
        method: "POST",
        endpoint: `orders/update_reservation_expiration`,
        json: {
          token: this.props.orderData.reservation_token,
          minutes: minutes
        }
      },
      function (err, response) {
        if (err) {
          console.log(err);
        }
      }
    );
  }

  _shouldApplyPassServerside() {
    // Right now we only use this complex pass application logic for reserved seating events.
    // See note in "order-seat-picker.jsx" about "When applying complex pass benefits...".
    return !!(
      this.context.tenant.owner === "5fcfefcf7f3c8a00aa281556" && // Outfest
      this.props.pass &&
      this.props.event &&
      this.props.event.venue &&
      this.props.event.venue.use_reserved_seating
    );
  }

  componentWillReceiveProps(props) {
    if (
      this._shouldApplyPassServerside() &&
      props.pass &&
      props.orderData &&
      !isEqual(props.orderData, this.__lastOrderData)
    ) {
      let orderData = cloneDeep(props.orderData);
      this.__lastOrderData = cloneDeep(orderData);
      console.log("Checkout: Serverside pass application triggered", orderData);
      this.setState({ appliedPassData: null });
      OrderUtil.testPass(PersonStore.getState().token, orderData)
        .then(res => {
          if (!isEqual(orderData, this.__lastOrderData)) {
            console.log(
              "Checkout: Serverside pass application skipped since stale",
              orderData
            );
            return;
          }
          console.log("Checkout: Serverside pass application success", res);
          this.setState({ appliedPassData: res });
        })
        .catch(e => {
          window.alert(`Failed to apply pass: ${e.message}`);
        });
    }

    if (props.outsideCloseRequest && this.state.heartbeatId) {
      this.setState({ showLeaveWarning: true });
      props.outsideCloseRequestCancel();
    }

    if (
      props.orderData &&
      props.orderData.seats_confirmed &&
      !this.props.orderSuccess &&
      !this.state.heartbeatId
    ) {
      this.startCountdown();
    }

    if (this.props.orderSuccess && this.state.heartbeatId) {
      clearInterval(this.state.heartbeatId);
      this.fireHeartbeat(0);
      this.setState({ heartbeatId: null });
    }

    // Remove donation on Sundance waitlistBadge order
    if (this.isSundance() && props.orderData && props.orderData.pass_code && props.orderData.pass_code === "waitlistBadge") {
      if (props.orderData.subitems.length > 1) {
        props.orderData.subitems = [props.orderData.subitems[0]];
      }
    }

    if (
      this.state.isUpdatingSundancePayment &&
      this.props.person.payment_method_summary
    ) {
      this.props.submit();
      this.setState({ isUpdatingSundancePayment: null });
    } else if (
      this.state.isUpdatingSundancePayment &&
      PersonStore.state.paymentInfoUpdateErrorMessage
    ) {
      this.setState({
        isUpdatingSundancePayment: null,
        tokenCreationErrorMessage:
          PersonStore.state.paymentInfoUpdateErrorMessage
      });
    }
  }

  _getProcessedOrder() {
    let order = assign({}, this.props.orderData),
      item = this.props.item || this.props.event || this.props.pass,
      ticketBuckets =
        this.props.event &&
        (this.props.event.ticket_buckets ||
          [].concat.apply(
            [],
            Object.values(this.props.event).map(v => v.ticket_buckets)
          )),
      _applyCouponState = {};

    let subitemPriceDetails = order.subitems.map((subitem, i) => {
      let originalPrice,
        price,
        name,
        subname,
        subsubname,
        centsOff,
        fee,
        quantity,
        quantityAvailable,
        tax,
        total;

      quantity = typeof subitem.quantity !== "undefined" ? subitem.quantity : 1;

      if (subitem.credits) {
        let passDiscount =
          this.context.appSettings.credits_discount.percent_off,
          level = this.context.appSettings.credits_levels.find(
            level => level.quantity === subitem.credits
          );

        name = item.name;
        price = level.price;

        if (subitem.with_discount) {
          subname = `With member discount`;
          price = price * (1 - passDiscount);
        }
      } else if (subitem.inline_donation) {
        name = util.formatInsertables(
          this.context.tenant.donate_inline_order_title,
          {
            name: () =>
              this.context.tenant.display_short_name ||
              this.context.tenant.display_name
          }
        );
        subname = this.context.tenant.donate_inline_order_message;
        price = subitem.price || 0;
        total = price;
        quantity = 1;
      } else if (subitem.ticket_bucket || subitem.event) {
        let variantText = "",
          ticketBucket =
            ticketBuckets &&
            ticketBuckets.find(b => b.id === subitem.ticket_bucket);

        // Widget view: support multiple items at once
        if (this.props.isWidgetView) {
          ticketBucket =
            this.props.subitemDetails[subitem.ticket_bucket || subitem.event] ||
            this.props.subitemDetails[subitem.event];
          if (ticketBucket) {
            item = ticketBucket.event;
            subitem.ticket_bucket = ticketBucket.id;
          }
        }

        if (!ticketBucket) {
          return;
        }
        if (this.props.pass && this.props.pass.id) {
          if (this._shouldApplyPassServerside() && this.state.appliedPassData) {
            if (
              this.state.appliedPassData.subitems &&
              this.state.appliedPassData.subitems[i] &&
              this.state.appliedPassData.subitems[i].price !== price
            ) {
              price = this.state.appliedPassData.subitems[i].price;
              quantityAvailable =
                this.state.appliedPassData.subitems[i].quantity_available;
            }
          } else {
            if (
              !ticketBucket.pass_adjusted ||
              !ticketBucket.pass_adjusted[this.props.pass.id]
            ) {
              return;
            }
            price = ticketBucket.pass_adjusted[this.props.pass.id].price;
            quantityAvailable =
              ticketBucket.pass_adjusted[this.props.pass.id].quantity_available;
          }
        } else {
          price = ticketBucket.price;
        }

        if (ticketBucket.max_quantity_per_person && !quantityAvailable) {
          quantityAvailable = ticketBucket.max_quantity_per_person;
        }

        if (ticketBucket.variable_price && !this.props.pass) {
          price = typeof subitem.price === "number" ? subitem.price : price;
          subitem.variable_price = ticketBucket.variable_price;
        }

        if (subitem.variant) {
          let variant = ticketBucket.variants.find(
            v => v.id === subitem.variant
          );
          variantText = ` – ${variant.name}`;
          price = variant.price;
        }

        if (ticketBucket.quantity_remaining === 0) {
          quantityAvailable = 0;
          variantText += " (SOLD\u00a0OUT)"; // non-breaking space
        }

        // Only allow buying a single virtual ticket - for Eventive Everywhere
        // checkout embeds in particular.
        if (item && item.is_virtual && quantityAvailable !== 0) {
          quantityAvailable = Math.min(quantityAvailable || 1, 1);
        }

        name = `${item.name ||
          (item[subitem.ticket_bucket] && item[subitem.ticket_bucket].name)
          }`;
        subname = `${ticketBucket.name}${variantText}${subitem.seats ? ` (${subitem.seats.join(", ")})` : ""
          }`;

        let relevantEvent = this.props.event
          ? this.props.event.start_time
            ? this.props.event
            : this.props.event[subitem.ticket_bucket]
          : null;
        if (
          (this.props.isCartView || this.props.isWidgetView) &&
          relevantEvent
        ) {
          subsubname = `${moment(relevantEvent.start_time).format("lll")}`;
        }

        if (order.with_credits) {
          quantityAvailable = quantityAvailable
            ? Math.min(quantityAvailable, this.props.creditsAvailable)
            : this.props.creditsAvailable;
          originalPrice = price;
          price = 0;
        }
      } else if (subitem.pass_bucket) {
        // Widget view: support multiple items at once
        if (this.props.isWidgetView) {
          item = this.props.subitemDetails[subitem.pass_bucket];
          if (!item) {
            return;
          }
        }

        if (this.props.usingPass) {
          name = item.name;
          subname = `With ${item.person.passes.find(p => p.id === this.props.usingPass)
              .pass_bucket.name
            } discount`;
          originalPrice = item.price;
          price = item.pass_adjusted[this.props.usingPass].price;
          quantityAvailable =
            item.pass_adjusted[this.props.usingPass].quantity_available;
        } else {
          name = item.name;
          price = item.sale_price || item.price;
        }
        if (subitem.names) {
          subname =
            subitem.names.slice(0, subitem.quantity).join(", ") +
            (subname ? ` (${subname})` : "");
        }
      } else if (subitem.item_bucket) {
        // Widget view: support multiple items at once
        if (this.props.isWidgetView) {
          item = this.props.subitemDetails[subitem.item_bucket];
          if (!item) {
            return;
          }
        }

        let variant = item.variants.find(v => v.id === subitem.variant);
        if (!variant) {
          return;
        }
        name = item.name;
        subname = variant.name;
        price = subitem.price || variant.price;
      } else {
        name = item.name;
        subname = item.subname;
        originalPrice = item.originalPrice;
        price = subitem.price || item.price || 0;
        quantity = quantity || item.quantity;
        if (item.quantity) {
          subitem.quantity = item.quantity;
        }
      }

      ({ originalPrice, price, fee, tax, total } = util.applyCoupon(
        subitem,
        price,
        item,
        (order.coupon &&
          order.coupon.subitems[i] &&
          order.coupon.subitems[i].price) ||
        null,
        this.context.appSettings,
        _applyCouponState
      ));

      if (
        order.coupon &&
        order.coupon.subitems[i] &&
        order.coupon.subitems[i].is_applicable &&
        order.coupon.subitems[i].price.cents_off > 0
      ) {
        centsOff = order.coupon.subitems[i].price.cents_off;
      }

      if (item && item.sales_disabled_unless_coupon & !quantityAvailable) {
        quantityAvailable =
          order.coupon &&
          order.coupon.subitems[i].is_applicable &&
          order.coupon.subitems[i].price.max_quantity;
      }

      if (!name) {
        return;
      }

      let originalTotal;
      if (originalPrice) {
        originalTotal = (originalPrice || price) * quantity;
      }

      // Inline gift option (used by widget view currently)
      if (subitem.gift) {
        subsubname = `Gift${subitem.gift_recipient ? ` to ${subitem.gift_recipient}` : ""
          }`;
      }

      return {
        name: name,
        subname: subname,
        subsubname: subsubname,
        start_time: this.props.event ? this.props.event.start_time : null,
        inline_donation: !!subitem.inline_donation,
        variable_price: subitem.variable_price ? subitem.variable_price : false,
        original_price: originalPrice,
        price: price,
        cents_off: centsOff,
        quantity: quantity,
        quantity_available: quantityAvailable,
        fixed_quantity: !!subitem.seats,
        fee: fee,
        tax: tax,
        original_total: originalTotal
          ? originalTotal + util.calculateFeeForPrice(originalTotal)
          : undefined,
        total: total,
        subitem: subitem // pass refernece for original data
      };
    });

    subitemPriceDetails = subitemPriceDetails.filter(i => !!i);

    if (
      this.props.isWidgetView &&
      subitemPriceDetails.length !== order.subitems.length
    ) {
      // Not yet complete
      return null;
    }

    order.subitem_prices = subitemPriceDetails;
    order.original_total = subitemPriceDetails.reduce(
      (t, i) => t + i.original_total,
      0
    );
    order.total = subitemPriceDetails.reduce((t, i) => t + i.total, 0);

    if (
      order.coupon &&
      order.coupon.gift_card &&
      order.coupon.gift_card_balance
    ) {
      order.original_total = order.original_total || order.total;
      order.total = Math.max(order.total - order.coupon.gift_card_balance, 0);
    }

    return order;
  }

  componentDidMount() {
    this.setState({ hasAcceptedTerms: false });
    CouponActions.reset.defer();
  }

  componentWillUnmount() {
    this.setState({ sundanceCouponStatus: undefined });
    if (this.state.heartbeatId) {
      clearInterval(this.state.heartbeatId);
      this.fireHeartbeat(0);
      this.setState({ heartbeatId: null });
    }
  }

  isSundance() {
    return (
      !!this.context.tenant.sundance_login ||
      this.context.tenant._force_sundance_mode
    );
  }

  isSundanceStaging() {
    return (
      !!this.context.tenant.sundance_login &&
      this.context.tenant.sundance_login_environment &&
      this.context.tenant.sundance_login_environment === "staging"
    );
  }

  useSundanceModals() {
    return !!this.context.tenant.use_sundance_modals;
  }

  async submitSundanceCheckout() {
    const person = this.props.person;
    const item = this.props.item || event || pass;
    const order =
      (item || (this.props.isWidgetView && this.props.subitemDetails)) &&
      this._getProcessedOrder();

    const collectingPaymentDetailsForFreePass = !!(
      this.props.pass &&
      !this.props.pass.price &&
      this.props.pass.payment_method_required_before_purchase
    );

    if (!this.context.tenant.checkout_v2_optout) {
      if (
        order.total === 0 &&
        collectingPaymentDetailsForFreePass &&
        !(person && person.payment_method_summary)
      ) {
        const result = await this.paymentMethodUpdater.submitForm();

        // if there's an error or missing response, stop. The PaymentMethodUpdater component will show the error.
        if (!result || result.error) {
          return;
        }
      } else if (order.total !== 0) {
        this.paymentWizard.onOrderFormSubmit();
        OrderActions.startOrderSubmission();
        return;
      }
    }

    if (!this.props.variablePrice && order.total === 0) {
      this.props.submit();
    } else if (person && !person.payment_method_summary) {
      // handle scenario where payment has not been entered but is required
      if (!this.state.stripe) {
        this.setState({
          tokenCreationErrorMessage:
            "You must enter payment information to complete this order."
        });
        return;
      }

      this.setState({
        isCreatingToken: true,
        tokenCreationErrorMessage: null
      });

      this.state.stripe
        .createToken({})
        .then(async ({ token, error }) => {
          if (error) {
            this.setState({
              isCreatingToken: false,
              tokenCreationErrorMessage: error.message,
              isUpdatingSundancePayment: null
            });
          } else {
            //this.props.onToken(token);
            this.setState({
              isCreatingToken: false,
              tokenCreationErrorMessage: null
            });

            this.setState({
              isUpdatingSundancePayment: true
            });
            PersonActions.updatePaymentInfo({ token: token.id });
          }
        })
        .catch(err => {
          this.setState({
            isCreatingToken: false,
            tokenCreationErrorMessage: err.message,
            isUpdatingSundancePayment: null
          });
        });
    } else {
      this.props.submit();
    }
  }

  apiRequest(request) {
    return new Promise((resolve, reject) =>
      api.request(
        {
          method: request.method,
          endpoint: request.url,
          json: request.data
        },
        (err, response) => {
          if (err) return reject(err);

          return resolve(response);
        }
      )
    );
  }

  getOrderData(order) {
    return {
      order: {
        ...order,
        ...(this.props.guestCheckoutActiveEmail
          ? {
            guest_mode: true,
            guest_email: this.props.guestCheckoutActiveEmail
          }
          : {}),
        coupon: order && order.coupon_code // overwrite the coupon object with the coupon_code string because that's what OrderPaymentWizard expects
      },
      event_bucket: null,
      token: PersonStore.getState().token,
      version: "2",
      manual_capture: true
    };
  }

  onOrderWaitingForCompletion(data) {
    this.setState({
      waitingForCheckoutCompletion: data
    });
  }

  onOrderCompleted(data) {
    OrderActions.orderCompleted.defer(data);
    this.setState({
      waitingForCheckoutCompletion: false
    });
  }

  onOrderCanceled(data) {
    console.log("onOrderCanceled", data);
  }

  onOpenPaymentMethodUpdater() {
    this.setState({
      disabled: true,
      isUpdatingPayment: true
    });
  }

  render() {
    let styles = this.getStyles(),
      screen = null,
      { event, pass } = this.props,
      quantityAvailable = this.props.quantity_available,
      isEvent = typeof event !== "undefined",
      isPass = typeof pass !== "undefined",
      item = this.props.item || event || pass,
      hasReservedSeating =
        event && event.venue && event.venue.use_reserved_seating,
      sundanceTermsRequired = !!this.context.tenant.sundance_login,
      hasTermsRequired =
        (item && item.terms_at_checkout) || sundanceTermsRequired;

    const display_passes_or_memberships = this.context.tenant.memberships_enabled ? this.context.tenant.display_memberships : this.context.tenant.display_passes;
    const display_pass_or_membership = this.context.tenant.memberships_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass;

    /*
    if (
      window.location.href.indexOf("nashfilm") > -1 &&
      navigator.userAgent.indexOf("gonative") > -1 &&
      /iPad|iPhone|iPod/.test(navigator.userAgent)
    ) {
      return (
        <div style={{ textAlign: "center", fontSize: 16, padding: 15 }}>
          Sorry, ordering is not available via the app. Please complete your
          purchase and then return to this page.
        </div>
      );
    }
    */

    if (
      this.state.waitingForCheckoutCompletion ||
      window.location.href.indexOf("_complete_checkout") !== -1
    ) {
      screen = (
        <OrderPaymentWizard
          getRef={this.setPaymentWizardRef}
          waitingForCheckoutCompletion={this.state.waitingForCheckoutCompletion}
          orderData={this.getOrderData(null)}
          apiRequest={this.apiRequest}
          // onOrderCanceled={() => onSuccess()}
          renderSubmitButton={() => null}
          onOrderCompleted={this.onOrderCompleted}
          onOrderCanceled={this.onOrderCanceled}
          isSundance={this.useSundanceModals()}
        // onLoginExpired={onLoginExpired}
        />
      );
    } else if (
      (this.context.tenant.checkout_v2_optout && // OrderPaymentWizard has its own spinner so we should never show this one
        this.props.orderInProgress) ||
      this.state.isUpdatingSundancePayment ||
      (this.props.orderSuccess && this.props.isWidgetView)
    ) {
      screen = (
        <div>
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ margin: 10.5 }}
          />
          <div
            style={{
              marginTop: "1em",
              fontSize: "12pt",
              color: "rgba(0,0,0,0.54)"
            }}
          >
            Submitting order...
          </div>
        </div>
      );
    } else if (this.state.showSeatWarning) {
      screen = (
        <div>
          <ReselectSeatsWarning
            stay={this._repickSeatsCancel}
            reselect={this._repickSeatsConfirm}
          />
        </div>
      );
    } else if (this.state.showLeaveWarning) {
      screen = (
        <div>
          <LeaveModalWarning
            stay={this._leaveModalCancel}
            leave={this._leaveModalConfirm}
          />
        </div>
      );
    } else if (this.props.orderSuccess) {
      screen = (
        <div>
          {this.isSundance() && this.useSundanceModals() ? (
            <div style={styles.sundanceHeader}>
              <div style={styles.sundanceHeaderTitle}>
                Thank You for Your Order
              </div>
              <div
                style={styles.sundanceHeaderCloseButton}
                onClick={() => {
                  const ticketsIndex = this.context.router && this.context.router.location
                    ? this.context.router.location.pathname.indexOf("/tickets")
                    : -1
                  if (ticketsIndex !== -1) {
                    const newPath = this.context.router.location.pathname.substring(0, ticketsIndex);
                    this.context.router.push(newPath);
                  }
                  else {
                    this.context.router.goBack();
                  }
                }}
              >
                <CloseIcon style={styles.sundanceHeaderCloseIcon} />
              </div>
            </div>
          ) : (
            <h2>Thank you for your order!</h2>
          )}
          {this.isSundance() && this.useSundanceModals() ? (
            <OrderSummarySundance
              event={this.props.event}
              pass={this.props.pass}
              order={this.props.completedOrder}
              person={this.props.person}
            />
          ) : (
            <OrderSummary
              order={this.props.completedOrder}
              person={this.props.person}
            />
          )}
        </div>
      );
    } else {
      let person =
        !this.context.appSettings.mock_logged_out && this.props.person,
        isLoggedIn =
          !this.context.appSettings.mock_logged_out && this.props.isLoggedIn,
        guestCheckoutActiveEmail = this.props.guestCheckoutActiveEmail,
        order =
          (item || (this.props.isWidgetView && this.props.subitemDetails)) &&
          this._getProcessedOrder(),
        hasInlineDonation =
          order && order.subitems.some(i => i.inline_donation && i.price),
        needsMailingAddress =
          ((event && event.require_mailing_address) ||
            (((item && item.donation) || hasInlineDonation) &&
              this.context.tenant.donate_require_mailing_address)) &&
          !(person && person.mailing_address),
        needsPhoneNumber =
          event &&
          event.require_phone_number &&
          !(person && person.phone_number),
        widgetViewPassForSupplementaryData =
          this.props.isWidgetView &&
          Object.values(this.props.subitemDetails).find(
            i => i.supplementary_data_required_before_purchase
          ),
        passForNeedsSupplementaryData =
          widgetViewPassForSupplementaryData || pass,
        collectingPaymentDetailsForFreePass = !!(
          pass &&
          !pass.price &&
          pass.payment_method_required_before_purchase
        );

      // Mailing list opt-in state
      if (
        typeof this.state.mailingListOptIn === "undefined" &&
        this.context.tenant.physical_show_mailing_list_opt_in
      ) {
        // set the default state
        this.state.mailingListOptIn =
          !this.context.tenant.physical_show_mailing_list_opt_in_unchecked;
        OrderActions.updateCurrentOrder.defer({
          do_not_email: !this.state.mailingListOptIn
        });
      }

      let needsSupplementaryData;
      if (widgetViewPassForSupplementaryData) {
        const targetSubitem =
          order &&
          order.subitems.find(
            i => i.pass_bucket === widgetViewPassForSupplementaryData.id
          );
        needsSupplementaryData =
          targetSubitem.quantity &&
          (!targetSubitem.supplementary_datas ||
            targetSubitem.quantity > targetSubitem.supplementary_datas.length);
      } else {
        needsSupplementaryData =
          pass &&
          pass.supplementary_data_required_before_purchase &&
          order &&
          order.subitems.some(
            i =>
              i.pass_bucket === passForNeedsSupplementaryData.id &&
              i.quantity &&
              (!i.supplementary_datas ||
                i.quantity > i.supplementary_datas.length)
          );
      }

      if (
        !order ||
        !order.subitems.length ||
        !order.subitem_prices ||
        !order.subitem_prices.length
      ) {
        screen = (
          <div>
            <CircularProgress
              mode="indeterminate"
              size={119}
              thickness={7}
              style={{ margin: 10.5 }}
            />
          </div>
        );
      } else if (hasReservedSeating && !order.seats_confirmed) {
        // Respect pass, coupon, etc. limits
        const quantityRestrictions =
          this.props.quantityAvailable ||
          event.ticket_buckets
            .map(b => {
              const details = order.subitem_prices.find(
                i => i.subitem.ticket_bucket === b.id
              );

              if (
                b.applicable_pass_buckets &&
                b.applicable_pass_buckets.length
              ) {
                if (
                  !this.props.pass ||
                  !b.applicable_pass_buckets.some(
                    bucketId =>
                      this.props.pass.pass_bucket &&
                      this.props.pass.pass_bucket.id === bucketId
                  )
                ) {
                  return null;
                }
              }

              return {
                category: b.reserved_seating_category,
                quantity:
                  details &&
                    typeof details.quantity_available !== "undefined" &&
                    !this._shouldApplyPassServerside() // if applying serverside, impose no restrictions on checkout -> will be applied in cart
                    ? details.quantity_available
                    : Number.MAX_SAFE_INTEGER
              };
            })
            .filter(x => !!x);

        screen = (
          <div>
            <h2>Seat Selection</h2>
            <OrderSeatPicker
              order={order}
              event={event}
              quantityAvailable={quantityRestrictions}
              updateCurrentOrder={this.props.updateCurrentOrder}
              onCancel={this.props.cancel}
            />
          </div>
        );
      } else if (
        (this.props.isQuickOrder && this.props.price === 0) ||
        order.type === "kiosk"
      ) {
        screen = (
          <div>
            <h2>Order Confirmation</h2>
            {this.props.orderErrorMessage ? (
              <div style={styles.error}>{this.props.orderErrorMessage}</div>
            ) : null}
            {this.isSundance() && this.useSundanceModals() ? (
              <OrderQuantitySelectSundance
                order={order}
                quantityAvailable={this.props.quantityAvailable}
                fixedQuantity={this.props.fixedQuantity}
                updateCurrentOrder={this.props.updateCurrentOrder}
              />
            ) : (
              <OrderQuantitySelect
                order={order}
                quantityAvailable={this.props.quantityAvailable}
                fixedQuantity={this.props.fixedQuantity}
                updateCurrentOrder={this.props.updateCurrentOrder}
              />
            )}
            <OrderActionButtons
              order={order}
              onCancel={this.onModalCancel}
              onSubmit={this.props.submit}
            />
          </div>
        );
      } else if (item && item.sales_disabled_unless_coupon && !order.coupon) {
        screen = (
          <div>
            <h2>
              Unlock{" "}
              {isEvent
                ? "ticket"
                : isPass
                  ? display_pass_or_membership
                  : ""}{" "}
              sales
            </h2>
            <div>
              Sales are currently locked. If you have a code, you can unlock
              them.
            </div>
            <OrderExtraEntry
              showCouponEntry={true}
              salesLocked={true}
              order={order}
              initialCouponCode={this.props.initialCouponCode}
              updateCurrentOrder={this.props.updateCurrentOrder}
              event={this.props.event}
              tenant={this.context.tenant}
            />
          </div>
        );
      } else if (this.props.orderShowDonateInterstitial) {
        const _submitInterstitial = amount => {
          let { subitems } = order;
          let existing = subitems.find(i => i.inline_donation);
          if (existing) {
            existing.price = amount;
          } else {
            subitems.push({ inline_donation: true, price: amount });
          }
          this.props.updateCurrentOrder({ subitems });
          this.props.submit();
        };

        screen = (
          <div>
            <h2>{this.context.tenant.donate_one_time_interstitial_header}</h2>
            <div>
              <InjectedTenantHtml
                content={
                  this.context.tenant.donate_one_time_interstitial_message
                }
                forceNewTab={true}
              />
            </div>
            {this.state.showCustomInterstitialDonationEntry ? (
              <div style={styles.donateButtonsContainer}>
                <CurrencyField
                  inputStyle={styles.donateButtonLabel}
                  value={this.state.customInterstitialDonation || 0}
                  onChange={e => {
                    this.setState({
                      customInterstitialDonation: e.target.value
                    });
                  }}
                  placeholder={"$0.00"}
                  style={{ width: 80 }}
                  autoFocus
                />
                <RaisedButton
                  style={Object.assign({}, styles.donateButton, {
                    marginLeft: 10
                  })}
                  label="Submit"
                  labelStyle={styles.donateButtonLabel}
                  primary={true}
                  onClick={() =>
                    _submitInterstitial(this.state.customInterstitialDonation)
                  }
                />
              </div>
            ) : (
              <div style={styles.donateButtonsContainer}>
                {this.context.tenant.donate_inline_levels.map(level => {
                  return (
                    <RaisedButton
                      key={level.amount}
                      style={styles.donateButton}
                      label={util.formatPrice(
                        level.amount,
                        true,
                        true /* no preceding CA */
                      )}
                      labelStyle={styles.donateButtonLabel}
                      primary={true}
                      onClick={() => _submitInterstitial(level.amount)}
                    />
                  );
                })}
                <RaisedButton
                  style={styles.donateButton}
                  label="Other"
                  labelStyle={styles.donateButtonLabel}
                  primary={true}
                  onClick={() =>
                    this.setState({ showCustomInterstitialDonationEntry: true })
                  }
                />
                <div style={{ fontStyle: "italic", fontSize: "0.9em" }}>
                  After selecting a donation amount, your order will be placed
                  immediately.
                </div>
              </div>
            )}
            <div>
              <FlatButton
                label={
                  this.state.showCustomInterstitialDonationEntry
                    ? "Back"
                    : "No thanks"
                }
                onClick={
                  this.state.showCustomInterstitialDonationEntry
                    ? () =>
                      this.setState({
                        showCustomInterstitialDonationEntry: false
                      })
                    : this.props.submit
                }
              />
            </div>
          </div>
        );
      } else {
        let recurrenceDetails =
          isPass && pass.recurrence_enabled
            ? {
              interval: pass.recurrence_interval,
              count: pass.recurrence_count
            }
            : undefined;
        let recurrenceLabel =
          recurrenceDetails &&
          (recurrenceDetails.interval === "year" &&
            recurrenceDetails.count === 1
            ? "annually"
            : `every ${recurrenceDetails.count} ${recurrenceDetails.interval}${recurrenceDetails.count > 1 ? "s" : ""
            }`);

        let showActionButtons =
          (guestCheckoutActiveEmail && order.total === 0) ||
          (isLoggedIn &&
            ((order.total === 0 && !collectingPaymentDetailsForFreePass) ||
              person.payment_method_summary) &&
            !needsMailingAddress &&
            !needsPhoneNumber &&
            !needsSupplementaryData);

        let canAddToCart =
          !this.props.isCartView &&
          !this.props.isQuickOrder &&
          this.context.appSettings.enable_cart &&
          isEvent;

        const _submitInterstitial = amount => {
          let { subitems } = order;
          let existing = subitems.find(i => i.inline_donation);
          if (existing) {
            existing.price = amount;
          } else {
            subitems.push({ inline_donation: true, price: amount });
          }
          this.props.updateCurrentOrder({ subitems });
        };

        // NOTE: The "sundanceCouponStatus === false" explicit conditional a few lines below is intentional and necessary
        screen = (
          <div>
            {this.isSundance() ? (
              <div>
                <div style={styles.sundanceHeader}>
                  <div style={styles.sundanceHeaderTitle}>
                    {this.props.isQuickOrder && this.useSundanceModals()
                      ? "Confirm Your Order"
                      : "Checkout"}
                  </div>
                  <div
                    style={styles.sundanceHeaderCloseButton}
                    onClick={this.props.cancel}
                  >
                    <CloseIcon style={styles.sundanceHeaderCloseIcon} />
                  </div>
                </div>
                {this.props.initialCouponCode ? (
                  this.state.sundanceCouponStatus === false ? (
                    <div style={styles.sundanceDiscountError}>
                      The discount code "<b>{this.props.initialCouponCode}</b>"
                      does not exist. Codes are case sensitive.
                    </div>
                  ) : this.state.sundanceCouponStatus === undefined ? (
                    <div style={styles.sundanceDiscountError}>
                      Checking discount code...
                    </div>
                  ) : null
                ) : null}
              </div>
            ) : (
              <h2>Checkout</h2>
            )}
            {hasReservedSeating ? (
              <div style={styles.timeout}>
                {this.state.showExpiredWarning ? (
                  <span>
                    <strong>Hold expired</strong>: You may still attempt to
                    place your order, but your seats may no longer be available.
                  </span>
                ) : (
                  <span>
                    Your seats are being held. Please complete your purchase
                    within{" "}
                    <strong>
                      {this.props.orderSeatTimeout ? (
                        <CountdownText
                          endTime={this.props.orderSeatTimeout}
                          onTimeExpired={this.onCountdownExpired.bind(this)}
                        />
                      ) : (
                        "06:00"
                      )}
                    </strong>{" "}
                    minutes.
                  </span>
                )}
              </div>
            ) : null}
            {this.props.orderErrorMessage ? (
              <div style={styles.error} dangerouslySetInnerHTML={{ __html: this.props.orderErrorMessage }} />
            ) : null}
            {this.isSundance() ? (
              <div
                style={styles.sundanceContainer}
                className="Eventive--Sundance"
              >
                <div style={styles.sundanceLeftContainer}>
                  {this.useSundanceModals() &&
                    (this.props.isQuickOrder ||
                      !this.props.isCheckoutWidgetView) ? (
                    <div>
                      {this.props.pass && this.props.pass.pass_bucket ? (
                        <div
                          style={{
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingTop: 10
                          }}
                        >
                          You are using: {this.props.pass.pass_bucket.name}
                        </div>
                      ) : null}
                      <OrderQuantitySelectSundance
                        order={order}
                        event={event}
                        tenant={this.context.tenant}
                        updateCurrentOrder={this.props.updateCurrentOrder}
                        quantityAvailable={this.props.quantityAvailable}
                        fixedQuantity={this.props.fixedQuantity}
                        hideQuantity={this.props.hideQuantity}
                        variablePrice={this.props.variablePrice}
                        allowZeroAll={this.props.isCartView}
                        isLoadingPrices={
                          this._shouldApplyPassServerside() &&
                          !this.state.appliedPassData
                        }
                        isSundance={this.isSundance()}
                      />
                    </div>
                  ) : null}
                  <div
                    style={
                      this.useSundanceModals() &&
                        !(this.props.isQuickOrder && order.total === 0)
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <OrderExtraEntry
                      order={order}
                      updateCurrentOrder={this.props.updateCurrentOrder}
                      initialCouponCode={this.props.initialCouponCode}
                      showCouponEntry={
                        !this.props.isWidgetView &&
                        (order.coupon ||
                          (!this.props.hideCouponEntry &&
                            !(this.props.isQuickOrder && order.total === 0)))
                      } // only show coupon entry for non-$0 events
                      showGiftEntry={this.props.showGiftEntry}
                      isWidgetView={this.props.isWidgetView}
                      isSundance={this.isSundance()}
                      updateCouponStatus={statusVal => {
                        if (statusVal !== this.state.sundanceCouponStatus) {
                          this.setState({
                            sundanceCouponStatus: statusVal
                          });
                        }
                      }}
                    />
                  </div>
                  {!(
                    this.props.isQuickOrder &&
                    order.total === 0 &&
                    this.useSundanceModals()
                  ) ? (
                    <div style={styles.sundanceSectionHeader}>
                      <span style={styles.sundanceSectionHeaderText}>
                        *Payment Method
                      </span>
                    </div>
                  ) : null}
                  {!(
                    this.props.isQuickOrder &&
                    order.total === 0 &&
                    this.useSundanceModals()
                  ) ? (
                    <div style={styles.sundancePaymentMethodContainer}>
                      {!this.context.tenant.checkout_v2_optout ? (
                        <div>
                          {!this.props.variablePrice &&
                            order.total === 0 &&
                            !collectingPaymentDetailsForFreePass &&
                            !this.props.isQuickOrder ? (
                            <div style={styles.sundancePayment}>
                              <div>
                                The total price of this order is{" "}
                                {util.formatPrice(0)}. You will not be charged.
                              </div>
                            </div>
                          ) : null}

                          {order.total === 0 &&
                            collectingPaymentDetailsForFreePass ? (
                            person && person.payment_method_summary ? (
                              <div style={styles.sundancePayment}>
                                For future purchases, we'll automatically charge
                                your saved card,{" "}
                                <span style={styles.savedCard}>
                                  {person.payment_method_summary}
                                </span>
                                {". "}(
                                <a
                                  href="javascript:void(0)"
                                  onClick={this.onOpenPaymentMethodUpdater}
                                >
                                  update card
                                </a>
                                )
                              </div>
                            ) : (
                              <div>
                                <p style={{ marginTop: 0 }}>
                                  You will not be charged in this order. Please
                                  save your credit card information for future
                                  orders.
                                </p>
                                <PaymentMethodUpdater
                                  getRef={this.setPaymentMethodUpdaterRef}
                                  submitButtonDisabled={true}
                                  setDisabledState={
                                    this.setPaymentWizardDisabledState
                                  }
                                />
                              </div>
                            )
                          ) : (
                            <OrderPaymentWizard
                              getRef={this.setPaymentWizardRef}
                              setDisabledState={
                                this.setPaymentWizardDisabledState
                              }
                              orderData={this.getOrderData(order)}
                              apiRequest={this.apiRequest}
                              renderSubmitButton={() => null}
                              onOrderWaitingForCompletion={
                                this.onOrderWaitingForCompletion
                              }
                              onOrderCompleted={this.onOrderCompleted}
                              onOrderCanceled={this.onOrderCanceled}
                              isSundance={this.useSundanceModals()}
                            />
                          )}
                        </div>
                      ) : !this.props.variablePrice && order.total === 0 ? (
                        <div style={styles.sundancePayment}>
                          <div>
                            The total price of this order is{" "}
                            {util.formatPrice(0)}. You will not be charged.
                          </div>
                        </div>
                      ) : person && person.payment_method_summary ? (
                        <div style={styles.sundancePayment}>
                          {"We'll charge your saved card: "}
                          <span style={styles.savedCard}>
                            {person.payment_method_summary}
                          </span>
                          {". "}(
                          <a
                            href="javascript:void(0)"
                            onClick={this.onOpenPaymentMethodUpdater}
                          >
                            update
                          </a>
                          )
                        </div>
                      ) : (
                        <div>
                          <div style={styles.sundancePayment}>
                            <p style={{ marginTop: 0 }}>
                              Please enter your credit card information (you'll
                              only need to do this once).
                            </p>
                          </div>
                          <Elements>
                            <PaymentMethodEntrySundance
                              onUpdate={stripeObject => {
                                this.setState({
                                  stripe: stripeObject
                                });
                              }}
                              paymentInfoUpdateErrorMessage={
                                this.state.tokenCreationErrorMessage
                              }
                            />
                          </Elements>
                        </div>
                      )}
                    </div>
                  ) : null}
                  {!(
                    this.props.isQuickOrder &&
                    order.total === 0 &&
                    this.useSundanceModals()
                  ) ? (
                    <div style={{ display: order.pass_code && order.pass_code == "waitlistBadge" ? "none" : "block" }}>
                      <div style={styles.sundanceSectionHeader}>
                        <span style={styles.sundanceSectionHeaderText}>
                          Support Sundance Institute
                        </span>
                      </div>
                      <div style={styles.sundanceDonationText}>
                        Join the movement in championing independent voices and
                        make a tax-deductible donation to the nonprofit Sundance
                        Institute today.
                      </div>
                      <div style={styles.sundanceDonateButtonsContainer}>
                        {this.state.showCustomInterstitialDonationEntry ? (
                          <div>
                            <CurrencyField
                              inputStyle={styles.sundanceDonateButtonLabel}
                              value={this.state.customInterstitialDonation || 0}
                              onChange={e => {
                                this.setState({
                                  customInterstitialDonation: e.target.value
                                });
                              }}
                              placeholder={"$0.00"}
                              style={{ width: 80 }}
                              autoFocus
                            />
                            <RaisedButton
                              style={Object.assign(
                                {},
                                styles.sundanceDonateButton,
                                {
                                  marginLeft: 10
                                }
                              )}
                              label="Submit"
                              labelStyle={styles.sundanceDonateButtonLabel}
                              primary={true}
                              onClick={() => {
                                this.setState({
                                  showCustomInterstitialDonationEntry: false
                                });
                                _submitInterstitial(
                                  this.state.customInterstitialDonation
                                );
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            {this.context.tenant.donate_inline_levels.map(
                              level => {
                                return (
                                  <RaisedButton
                                    key={level.amount}
                                    style={styles.sundanceDonateButton}
                                    label={util.formatPrice(
                                      level.amount,
                                      true,
                                      true /* no preceding CA */
                                    )}
                                    labelStyle={
                                      styles.sundanceDonateButtonLabel
                                    }
                                    primary={true}
                                    onClick={() =>
                                      _submitInterstitial(level.amount)
                                    }
                                  />
                                );
                              }
                            )}
                            <RaisedButton
                              style={styles.sundanceDonateButton}
                              label="Other"
                              labelStyle={styles.sundanceDonateButtonLabel}
                              primary={true}
                              onClick={() =>
                                this.setState({
                                  showCustomInterstitialDonationEntry: true
                                })
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div style={styles.sundanceRightContainer}>
                  <CheckoutOrderSummary
                    styles={styles.sundanceCheckoutSummary}
                    order={order}
                    useSundanceModals={this.useSundanceModals()}
                  />
                  {hasTermsRequired && sundanceTermsRequired ? (
                    <div style={styles.sundanceTerms}>
                      <Checkbox
                        style={{ width: 260, marginLeft: 5 }}
                        name="sundanceTerm1"
                        inputStyle={styles.sundanceTermsCheckboxInput}
                        label={
                          <div style={styles.sundanceTermsCheckboxLabel}>
                            *I agree to the{" "}
                            <a
                              href="https://festival.sundance.org/terms-and-conditions"
                              target="_blank"
                            >
                              Purchasing Terms
                            </a>
                            .
                          </div>
                        }
                        checked={this.state.sundanceTerm1Checked}
                        onCheck={(e, checked) => {
                          this.setState({
                            sundanceTerm1Checked: checked,
                            hasAcceptedTerms: checked
                          });
                        }}
                      />
                    </div>
                  ) : null}
                  <div style={styles.sundanceCheckoutButtonContainer}>
                    <FlatButton
                      label="Complete Purchase"
                      style={styles.sundanceCheckoutButton}
                      labelStyle={styles.sundanceCheckoutButtonLabel}
                      disabled={
                        (!this.context.tenant.checkout_v2_optout &&
                          this.state.paymentWizardSubmitDisabled &&
                          !(
                            order.total === 0 &&
                            collectingPaymentDetailsForFreePass &&
                            person &&
                            person.payment_method_summary
                          ) &&
                          !(
                            this.props.isQuickOrder &&
                            order.total === 0 &&
                            this.useSundanceModals()
                          )) ||
                        (hasTermsRequired && !this.state.hasAcceptedTerms) ||
                        order.subitems.reduce(
                          (t, i) => t + (i.inline_donation ? 0 : i.quantity),
                          0
                        ) === 0
                      }
                      onClick={this.submitSundanceCheckout}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <OrderQuantitySelect
                order={order}
                event={event}
                tenant={this.context.tenant}
                updateCurrentOrder={this.props.updateCurrentOrder}
                quantityAvailable={this.props.quantityAvailable}
                fixedQuantity={this.props.fixedQuantity}
                hideQuantity={this.props.hideQuantity}
                variablePrice={this.props.variablePrice}
                allowZeroAll={this.props.isCartView}
                isLoadingPrices={
                  this._shouldApplyPassServerside() &&
                  !this.state.appliedPassData
                }
              />
            )}
            {!this.isSundance() ? (
              <OrderExtraEntry
                order={order}
                updateCurrentOrder={this.props.updateCurrentOrder}
                initialCouponCode={this.props.initialCouponCode}
                showCouponEntry={
                  !this.props.isWidgetView &&
                  (order.coupon ||
                    (!this.props.hideCouponEntry &&
                      !(this.props.isQuickOrder && order.total === 0)))
                } // only show coupon entry for non-$0 events
                showGiftEntry={this.props.showGiftEntry}
                isWidgetView={this.props.isWidgetView}
              />
            ) : null}
            {recurrenceDetails ? (
              <div style={styles.recurrence}>
                <strong>Take note:</strong> Your{" "}
                {order.quantity === 1
                  ? display_pass_or_membership
                  : display_passes_or_memberships}{" "}
                will automatically be renewed {recurrenceLabel}. You can cancel
                at any time using this website (a direct link will also be
                included in your order confirmation email).
              </div>
            ) : null}
            {// Ticket sales - pass advert
              !person &&
                this.props.event &&
                this.context.tenant.ticket_sales_pass_advert ? (
                <div style={styles.account}>
                  {util.formatInsertables(
                    this.context.tenant.ticket_sales_pass_advert,
                    {
                      buy_pass_link: t => (
                        <Link
                          key="buy_pass_link"
                          to={`/${this.context.tenant.passes_url_pathname}/buy`}
                        >
                          {t}
                        </Link>
                      )
                    }
                  )}
                </div>
              ) : null}
            {// Ticket sales - membership advert
              !person &&
                this.props.event &&
                this.context.tenant.membership_enabled &&
                this.context.tenant.ticket_sales_membership_advert ? (
                <div style={styles.account}>
                  {util.formatInsertables(
                    this.context.tenant.ticket_sales_membership_advert,
                    {
                      buy_pass_link: t => (
                        <Link
                          key="buy_pass_link"
                          to={`/${this.context.tenant.memberships_url_pathname}/buy`}
                        >
                          {t}
                        </Link>
                      )
                    }
                  )}
                </div>
              ) : null
            }

            {this.context.tenant.physical_show_mailing_list_opt_in ? (
              <div style={{ marginBottom: "1em", textAlign: "left" }}>
                <Checkbox
                  label={
                    <div
                      className="no-p-margin"
                      dangerouslySetInnerHTML={{
                        __html:
                          this.context.tenant
                            .physical_mailing_list_opt_in_message
                      }}
                    />
                  }
                  checked={!!this.state.mailingListOptIn}
                  onCheck={(e, checked) => {
                    this.setState({ mailingListOptIn: checked }, () => {
                      OrderActions.updateCurrentOrder({
                        do_not_email: !checked
                      });
                    });
                  }}
                />
              </div>
            ) : null}

            {!this.isSundance() ? (
              isLoggedIn || guestCheckoutActiveEmail ? (
                <div>
                  <div style={styles.accountDetail}>
                    <div style={styles.account}>
                      {guestCheckoutActiveEmail ? (
                        <span>
                          {`Your receipt will be emailed to ${guestCheckoutActiveEmail}.`}{" "}
                          (
                          <LinkLike
                            onClick={() => PersonActions.setGuestCheckout("")}
                          >
                            edit
                          </LinkLike>
                          )
                        </span>
                      ) : (
                        `Currently logged in as ${person.email}.`
                      )}
                    </div>
                    {!this.props.variablePrice && order.total === 0 ? (
                      <div style={styles.payment}>
                        <div>
                          The total price of this order is {util.formatPrice(0)}
                          . You will not be charged.
                        </div>
                        {this.context.tenant.pass_ticket_return_policy &&
                          this.props.isQuickOrder ? (
                          <div style={{ fontWeight: "bold" }}>
                            {this.context.tenant.pass_ticket_return_policy}
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {guestCheckoutActiveEmail && order.total > 0 ? (
                      <div>
                        <h3 style={{ marginBottom: "0.5em" }}>
                          Payment information
                        </h3>
                        <p style={{ marginTop: 0 }}>
                          Please enter your credit card information. Your
                          information will not be saved.
                        </p>

                        {!this.context.tenant.checkout_v2_optout ? (
                          <OrderPaymentWizard
                            getRef={this.setPaymentWizardRef}
                            setDisabledState={this.setPaymentWizardDisabledState}
                            orderData={this.getOrderData(order)}
                            apiRequest={this.apiRequest}
                            guestModeEmail={guestCheckoutActiveEmail}
                            renderSubmitButton={({
                              disabled,
                              isWorking,
                              isSubmittingOrder
                            }) => {
                              return (
                                <RaisedButton
                                  label={
                                    isSubmittingOrder
                                      ? "Purchasing..."
                                      : `${this.props.buyLabel ||
                                      (order.gift ? "Gift" : "Buy")
                                      }${this.props.canAddToCart ? " now" : ""
                                      } (${util.formatPrice(order.total)})`
                                  }
                                  primary={true}
                                  disabled={disabled}
                                  style={{
                                    float: "right"
                                  }}
                                  type="submit"
                                ></RaisedButton>
                              );
                            }}
                            onOrderWaitingForCompletion={
                              this.onOrderWaitingForCompletion
                            }
                            onOrderCompleted={this.onOrderCompleted}
                            onOrderCanceled={this.onOrderCanceled}
                            isSundance={this.useSundanceModals()}
                          />
                        ) : (
                          <PaymentMethodUpdater
                            onToken={token => {
                              this.props.updateCurrentOrder({
                                guest_mode: true,
                                guest_email: guestCheckoutActiveEmail,
                                guest_payment_token: token.id
                              });
                              setTimeout(() => {
                                this.props.submit();
                              }, 0);
                            }}
                            submitButtonLabel={`Place order (${util.formatPrice(
                              order.total
                            )})`}
                          />
                        )}
                      </div>
                    ) : (person && person.payment_method_summary) ||
                      (order.total === 0 &&
                        !collectingPaymentDetailsForFreePass) ? (
                      <div>
                        {order.total > 0 || this.props.forceShowPaymentSummary ? (
                          <div style={styles.payment}>
                            {"We'll automatically charge your saved card, "}
                            <span style={styles.savedCard}>
                              {person.payment_method_summary}
                            </span>
                            {". "}(<Link to="/account/payment?checkout=true">update card</Link>)
                          </div>
                        ) : collectingPaymentDetailsForFreePass ? (
                          <div style={styles.payment}>
                            For future purchases, we'll automatically charge your
                            saved card,{" "}
                            <span style={styles.savedCard}>
                              {person.payment_method_summary}
                            </span>
                            {". "}(<Link to="/account/payment?checkout=true">update card</Link>)
                          </div>
                        ) : null}
                        {needsMailingAddress || needsPhoneNumber ? (
                          <div>
                            <h3 style={{ marginBottom: "0.5em" }}>
                              {needsMailingAddress && needsPhoneNumber
                                ? "Contact details"
                                : needsMailingAddress
                                  ? "Mailing address"
                                  : "Phone number"}
                            </h3>
                            <p
                              style={Object.assign(
                                { marginTop: 0 },
                                this.context.tenant.charity_is_canadian && {
                                  maxWidth: 485,
                                  marginLeft: "auto",
                                  marginRight: "auto"
                                }
                              )}
                            >
                              One more thing &ndash; please provide us with your{" "}
                              {this.context.tenant.charity_is_canadian ? (
                                <span>
                                  full legal name (including middle&nbsp;initial)
                                  and
                                </span>
                              ) : (
                                ""
                              )}{" "}
                              {needsMailingAddress && needsPhoneNumber
                                ? "mailing address and phone number"
                                : needsMailingAddress
                                  ? "mailing address"
                                  : "phone number"}{" "}
                              {hasInlineDonation && !needsPhoneNumber
                                ? "for your tax receipt"
                                : ""}{" "}
                              (you'll only need to do this once).
                            </p>
                            <ContactInfoUpdater
                              includeLegalName={
                                this.context.tenant.charity_is_canadian
                              }
                              includeMailingAddress={needsMailingAddress}
                              includePhoneNumber={needsPhoneNumber}
                              onCancel={this.props.cancel}
                            />
                          </div>
                        ) : needsSupplementaryData ? (
                          <div>
                            <h3 style={{ marginBottom: "0.5em" }}>
                              Details for your new{" "}
                              {order.subitems.find(
                                i =>
                                  i.pass_bucket ===
                                  passForNeedsSupplementaryData.id
                              ).quantity > 1
                                ? display_passes_or_memberships
                                : display_pass_or_membership}
                            </h3>
                            <p style={{ marginTop: 0 }}>
                              Please click "edit details" below to provide the
                              information necessary to create your new{" "}
                              {order.subitems.find(
                                i =>
                                  i.pass_bucket ===
                                  passForNeedsSupplementaryData.id
                              ).quantity > 1
                                ? display_passes_or_memberships
                                : display_pass_or_membership}
                              .
                            </p>
                            <SupplementaryDataCheckoutEntry
                              pass={passForNeedsSupplementaryData}
                              order={order}
                              updateCurrentOrder={this.props.updateCurrentOrder}
                            />
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <div>
                        {!(needsMailingAddress || needsPhoneNumber || needsSupplementaryData) ? (
                          <div>
                            <h3 style={{ marginBottom: "0.5em" }}>
                              Payment information
                            </h3>
                            {order.total === 0 &&
                              collectingPaymentDetailsForFreePass ? (
                              <p style={{ marginTop: 0 }}>
                                You will not be charged in this order. Please save
                                your credit card information for future orders.
                              </p>
                            ) : (
                              <p style={{ marginTop: 0 }}>
                                Please enter your credit card information (you'll only
                                need to do this once).
                              </p>
                            )}
                            {!this.context.tenant.checkout_v2_optout ? (
                              <OrderPaymentWizard
                                getRef={this.setPaymentWizardRef}
                                setDisabledState={this.setPaymentWizardDisabledState}
                                orderData={this.getOrderData(order)}
                                apiRequest={this.apiRequest}
                                renderSubmitButton={({
                                  disabled,
                                  isWorking,
                                  isSubmittingOrder
                                }) => {
                                  return (
                                    <RaisedButton
                                      label={
                                        isSubmittingOrder
                                          ? "Purchasing..."
                                          : `${this.props.buyLabel ||
                                          (order.gift ? "Gift" : "Buy")
                                          }${this.props.canAddToCart ? " now" : ""
                                          } (${util.formatPrice(order.total)})`
                                      }
                                      primary={true}
                                      disabled={disabled}
                                      style={{
                                        float: "right"
                                      }}
                                      type="submit"
                                    ></RaisedButton>
                                  );
                                }}
                                onOrderWaitingForCompletion={
                                  this.onOrderWaitingForCompletion
                                }
                                onOrderCompleted={this.onOrderCompleted}
                                onOrderCanceled={this.onOrderCanceled}
                                isSundance={this.useSundanceModals()}
                              />
                            ) : (
                              <PaymentMethodUpdater />
                            )}
                          </div>
                        ) : null}
                        {needsMailingAddress || needsPhoneNumber ? (
                          <div>
                            <h3 style={{ marginBottom: "0.5em" }}>
                              {needsMailingAddress && needsPhoneNumber
                                ? "Contact details"
                                : needsMailingAddress
                                  ? "Mailing address"
                                  : "Phone number"}
                            </h3>
                            <p
                              style={Object.assign(
                                { marginTop: 0 },
                                this.context.tenant.charity_is_canadian && {
                                  maxWidth: 485,
                                  marginLeft: "auto",
                                  marginRight: "auto"
                                }
                              )}
                            >
                              Please provide us with your{" "}
                              {this.context.tenant.charity_is_canadian ? (
                                <span>
                                  full legal name (including middle&nbsp;initial)
                                  and
                                </span>
                              ) : (
                                ""
                              )}{" "}
                              {needsMailingAddress && needsPhoneNumber
                                ? "mailing address and phone number"
                                : needsMailingAddress
                                  ? "mailing address"
                                  : "phone number"}{" "}
                              {hasInlineDonation && !needsPhoneNumber
                                ? "for your tax receipt"
                                : ""}{" "}
                              (you'll only need to do this once).
                            </p>
                            <ContactInfoUpdater
                              includeLegalName={
                                this.context.tenant.charity_is_canadian
                              }
                              includeMailingAddress={needsMailingAddress}
                              includePhoneNumber={needsPhoneNumber}
                              onCancel={this.props.cancel}
                            />
                          </div>
                        ) : needsSupplementaryData ? (
                          <div>
                            <h3 style={{ marginBottom: "0.5em" }}>
                              Details for your new{" "}
                              {order.subitems.find(
                                i =>
                                  i.pass_bucket ===
                                  passForNeedsSupplementaryData.id
                              ).quantity > 1
                                ? display_passes_or_memberships
                                : display_pass_or_membership}
                            </h3>
                            <p style={{ marginTop: 0 }}>
                              Please click "edit details" below to provide the
                              information necessary to create your new{" "}
                              {order.subitems.find(
                                i =>
                                  i.pass_bucket ===
                                  passForNeedsSupplementaryData.id
                              ).quantity > 1
                                ? display_passes_or_memberships
                                : display_pass_or_membership}
                              .
                            </p>
                            <SupplementaryDataCheckoutEntry
                              pass={passForNeedsSupplementaryData}
                              order={order}
                              updateCurrentOrder={this.props.updateCurrentOrder}
                            />
                          </div>
                        ) : null}
                        {canAddToCart ? (
                          <div>
                            <p style={{ marginTop: "1rem", fontStyle: "italic" }}>
                              Not ready to place your order yet?{" "}
                              <OrderActionButtons
                                order={order}
                                canAddToCart={canAddToCart}
                                disabled={
                                  (hasTermsRequired &&
                                    !this.state.hasAcceptedTerms) ||
                                  order.subitems.reduce(
                                    (t, i) =>
                                      t + (i.inline_donation ? 0 : i.quantity),
                                    0
                                  ) === 0
                                }
                                onForceCancel={this.props.cancel}
                                onlyCartSlim={true}
                              />
                            </p>
                          </div>
                        ) : null}
                      </div>
                    )}
                    {showActionButtons &&
                      hasTermsRequired &&
                      !sundanceTermsRequired ? (
                      <div style={styles.terms}>
                        <InjectedTenantHtml
                          content={{ __html: item.terms_at_checkout }}
                          forceNewTab={true}
                        />
                        <Checkbox
                          style={{ marginTop: "1em" }}
                          label="I accept the above terms."
                          checked={this.state.hasAcceptedTerms}
                          onCheck={(e, checked) =>
                            this.setState({ hasAcceptedTerms: checked })
                          }
                        />
                      </div>
                    ) : null}
                    {showActionButtons &&
                      !order.pass &&
                      event &&
                      this.context.tenant.standalone_tickets_checkout_message
                        .__html ? (
                      <div style={styles.terms}>
                        <InjectedTenantHtml
                          content={
                            this.context.tenant
                              .standalone_tickets_checkout_message
                          }
                          forceNewTab={true}
                        />
                      </div>
                    ) : null}
                  </div>
                  {this.state.isUpdatingPayment ? (
                    <Card
                      style={{
                        marginTop: "1em",
                        marginBottom: "1em",
                        padding: "1em"
                      }}
                    >
                      <PaymentMethodUpdater
                        getRef={this.setPaymentMethodUpdaterRef}
                        submitButtonDisabled={false}
                        submitButtonLabel="Save"
                        onPaymentMethodUpdated={() => {
                          this.setState({
                            disabled: false,
                            isUpdatingPayment: false,
                            paymentMethodUpdaterRef: null
                          });
                        }}
                        onCancel={() => {
                          this.setState({
                            disabled: false,
                            isUpdatingPayment: false,
                            paymentMethodUpdaterRef: null
                          });
                        }}
                      />
                    </Card>
                  ) : null}
                </div>
              ) : (
                <AccountCreation
                  style={{ marginTop: "1em" }}
                  actionVerb={this.props.actionVerb}
                  allowGuestCheckout={this.props.allowGuestCheckout}
                  loginProps={{
                    backIfTargetOkay: true,
                    targetResourceType: isEvent
                      ? "event"
                      : isPass
                        ? "pass"
                        : "unknown",
                    targetResourceId: item ? item.id : undefined
                  }}
                  redirectOnLogin={(username, firstName) => {
                    if (isEvent) {
                      this.context.router.push({
                        pathname: "/login",
                        query: {
                          next: `/schedule/${item ? item.id : undefined}`
                        },
                        state: {
                          username,
                          firstName,
                          backIfTargetOkay: true,
                          targetResourceType: "event",
                          targetResourceId: item ? item.id : undefined
                        }
                      });
                      return true;
                    } else if (isPass) {
                      this.context.router.push({
                        pathname: "/login",
                        query: {
                          next: `/${this.context.tenant.membership_enabled ? this.context.tenant.memberships_url_pathname : this.context.tenant.passes_url_pathname}/buy`
                        },
                        state: {
                          username,
                          firstName,
                          backIfTargetOkay: true,
                          targetResourceType: "pass",
                          targetResourceId: item ? item.id : undefined
                        }
                      });
                      return true;
                    } else if (item && item.credits) {
                      this.context.router.push({
                        pathname: "/login",
                        query: { next: `/credits` },
                        state: { username, firstName }
                      });
                      return true;
                    }
                  }}
                />
              )
            ) : null}
            {showActionButtons && !this.isSundance() ? (
              <OrderActionButtons
                order={order}
                person={person}
                canAddToCart={canAddToCart}
                disabled={
                  this.state.disabled ||
                  this.state.isSubmitting ||
                  (hasTermsRequired && !this.state.hasAcceptedTerms) ||
                  order.subitems.reduce(
                    (t, i) => t + (i.inline_donation ? 0 : i.quantity),
                    0
                  ) === 0
                }
                buyLabel={
                  this.state.isSubmitting
                    ? "Purchasing..."
                    : this.props.buyLabel
                }
                cancelLabel={hasReservedSeating ? "Reselect seats" : "Cancel"}
                onCancel={
                  hasReservedSeating ? this._repickSeats : this.props.cancel
                }
                onForceCancel={this.props.cancel}
                onSubmit={() => {
                  this.setState({
                    isSubmitting: true
                  });
                  this.props.submit();
                }}
                buyTooltip={
                  hasTermsRequired && !this.state.hasAcceptedTerms
                    ? `Please check the box${sundanceTermsRequired ? "es" : ""
                    } to accept the terms before continuing.`
                    : null
                }
              />
            ) : null}
          </div>
        );
      }
    }

    return (
      <div className="Eventive--Checkout" style={styles.container}>
        <Elements>{screen}</Elements>
      </div>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/app/components/partials/checkout.jsx